import { Component, Vue } from 'vue-property-decorator'

import { alert, AlertParams } from '@/store/modules/alert'

@Component
export class Alert extends Vue {
  alertModule = alert.context(this.$store)

  openAlert({ type, message, duration }: AlertParams) {
    this.alertModule.mutations.openAlert({ type, message, duration })
  }
}
